// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"23e96bd5","265":"ef004c12","318":"76288aa2","345":"670ad2a0","391":"282e7ea9","453":"5a3b522e","562":"12bb9a42","914":"dff90889"}[chunkId] + ".chunk.js";
};